import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import { Button } from "../../../Button";
import { useFlavourCarousel } from "../../FlavourCarouselContext";
import { FlavourRating } from "../FlavourRating/FlavourRating";
import styles from "./FlavourCarouselCard.module.scss";
export const PRODUCT_GRADIENTS = {
    blue1: "var(--des-product-gradient-blue1)",
    blue2: "var(--des-product-gradient-blue2)",
    blue3: "var(--des-product-gradient-blue3)",
    blue4: "var(--des-product-gradient-blue4)",
    brown1: "var(--des-product-gradient-brown1)",
    brown2: "var(--des-product-gradient-brown2)",
    brown3: "var(--des-product-gradient-brown3)",
    green1: "var(--des-product-gradient-green1)",
    green2: "var(--des-product-gradient-green2)",
    green3: "var(--des-product-gradient-green3)",
    grey: "var(--des-product-gradient-grey)",
    orange1: "var(--des-product-gradient-orange1)",
    orange2: "var(--des-product-gradient-orange2)",
    pink1: "var(--des-product-gradient-pink1)",
    pink2: "var(--des-product-gradient-pink2)",
    purple1: "var(--des-product-gradient-purple1)",
    purple2: "var(--des-product-gradient-purple2)",
    purple3: "var(--des-product-gradient-purple3)",
    red1: "var(--des-product-gradient-red1)",
    red2: "var(--des-product-gradient-red2)",
    red3: "var(--des-product-gradient-red3)",
    red4: "var(--des-product-gradient-red4)",
    teal: "var(--des-product-gradient-teal)",
    yellow1: "var(--des-product-gradient-yellow1)",
    yellow2: "var(--des-product-gradient-yellow2)",
    yellow3: "var(--des-product-gradient-yellow3)",
    yellow4: "var(--des-product-gradient-yellow4)",
};
const { sanitize } = dompurify;
export const FlavourCarouselCard = ({ backgroundColor, backgroundGradient, image, title, description, theme, flavours, cta, }) => {
    const { isInversed } = useFlavourCarousel();
    return (_jsxs("div", { className: classNames(styles.flavourCard, {
            [styles.inversed]: isInversed,
            ["light-theme"]: theme === "light",
            ["dark-theme"]: theme === "dark",
        }), "data-testid": "flavourCarouselCard", style: { background: PRODUCT_GRADIENTS[backgroundGradient] || backgroundColor }, children: [image && _jsx("img", { src: image.src, alt: image.alt, className: styles.image }), _jsxs("div", { className: styles.content, children: [_jsx("div", { className: styles.title, children: title }), _jsx("div", { className: styles.description, dangerouslySetInnerHTML: {
                            __html: sanitize(description),
                        } }), flavours?.length > 0 && (_jsx("div", { className: styles.ratings, children: flavours?.map(({ label, rating }, index) => (_jsx(FlavourRating, { label: label, rating: rating }, `${label}-${rating}-${index}`))) })), cta?.label && (_jsx(Button, { size: "small", href: cta.url, className: styles.cta, target: cta.target, children: cta.label }))] })] }));
};
//# sourceMappingURL=FlavourCarouselCard.js.map